import { Card, CardContent, Grid, Icon, Typography } from '@mui/material';
import React from 'react'
import { CreditCard, Filter, Info, Search, User } from 'react-feather';
import { AllowedAccess } from 'react-permission-role';
import { useLocation, useParams } from 'react-router-dom';
import { FilterPayments } from './PaymentsFilter/FilterPayments';
import { PaymentsTable } from './PaymentsTable/PaymentsTable';
import { useFechInitVehiclePayments } from './hooks';
import { ModalModule } from './Modal';
import { CreditInformation } from './CreditInformation/CreditInformation';
import { LinearLoading } from 'common';

export const VehiclesPayments = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehiclePayments({ location, paramsURL })

  const { FetchData } = useFetchInit
  const { fetchAllVehiclePayments: { loadingFetchVehiclePayments } } = FetchData

  return (
    <AllowedAccess permissions={['103_VEHICULOS_PAGOS']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        <div className='panel-body' id='listadoregistros'>
          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <CardContent>
                  <ModalModule useFetchInit={useFetchInit} />

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 1 }}>
                    <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                      Filtro
                      <Icon component={Filter} sx={{ ml: 1, fontSize: '1.5rem' }} />
                    </Typography>
                  </Grid>
                  <FilterPayments useFetchInit={useFetchInit} />

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1 }}>
                    <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                      Informacion del Credito
                      <Icon component={Info} sx={{ ml: 1, fontSize: '1.5rem' }} />
                    </Typography>
                  </Grid>

                  <CreditInformation useFetchInit={useFetchInit} />

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 5, mb: 1 }}>
                    <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                      Pagos
                      <Icon component={CreditCard} sx={{ ml: 1, fontSize: '1.5rem' }} />
                    </Typography>
                  </Grid>
                  {loadingFetchVehiclePayments && <LinearLoading />}
                  <PaymentsTable useFetchInit={useFetchInit} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>
    </AllowedAccess>
  )
}
